var _path, _g, _path2, _g2, _path3, _g3, _path4, _ellipse, _g4, _path5, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateEmailSucceed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 145,
    viewBox: "0 0 131 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_527_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 120,
    width: 23,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1028 120.867L82.5258 121.899L84.3563 134.026C82.9549 133.911 79.5314 133.833 77.0484 134.442C73.9446 135.203 73.3525 138.926 71.0609 142.004C69.2275 144.467 64.5346 144.728 62.4174 144.551L67.1028 120.867Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_527_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1028 120.867L82.5258 121.899L84.3563 134.026C82.9549 133.911 79.5314 133.833 77.0484 134.442C73.9446 135.203 73.3525 138.926 71.0609 142.004C69.2275 144.467 64.5346 144.728 62.4174 144.551L67.1028 120.867Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.218 136.025C68.7786 133.997 65.6028 130.654 64.1666 129.649L68.4972 125.171C72.0771 129.771 78.9248 139.066 77.6758 139.449C76.1145 139.927 71.6574 138.052 70.218 136.025Z",
    fill: "#303858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.575 120.355L68.2423 127.347M64.8706 145.037L66.0588 138.803M66.0588 138.803C69.7826 137.962 71.3542 138.762 73.6531 141.431M66.0588 138.803L68.2423 127.347M68.2423 127.347C72.5056 127.773 74.1811 126.382 75.8358 120.858",
    stroke: "#616987",
    strokeWidth: 0.945908
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_527_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 87,
    width: 131,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6402 91.8462L52.1506 87.7452L50.5699 91.5681C43.9467 90.9781 27.5115 90.6365 14.7559 93.99C-1.18867 98.182 -2.58443 110.469 4.86244 117.639C10.8199 123.375 43.978 131.023 59.8123 134.13L62.597 119.026L71.5194 119.575L76.3997 140.174C85.6356 140.059 107.369 138.225 120.415 131.802C136.723 123.774 131.314 109.851 115.196 103.868C102.301 99.0819 89.4003 96.8522 84.5618 96.3357L83.6402 91.8462Z",
    fill: "#FF5C3D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_527_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6402 91.8462L52.1506 87.7452L50.5699 91.5681C43.9467 90.9781 27.5115 90.6365 14.7559 93.99C-1.18867 98.182 -2.58443 110.469 4.86244 117.639C10.8199 123.375 43.978 131.023 59.8123 134.13L62.597 119.026L71.5194 119.575L76.3997 140.174C85.6356 140.059 107.369 138.225 120.415 131.802C136.723 123.774 131.314 109.851 115.196 103.868C102.301 99.0819 89.4003 96.8522 84.5618 96.3357L83.6402 91.8462Z",
    fill: "#01B388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 104.415L21.219 105.052M63.0311 119.355L64.5005 110.689L55.4556 109.511M55.4556 109.511L50.0539 133.2M55.4556 109.511L21.219 105.052M19.1212 102.326L21.219 105.052M68.484 88.9952L68.3044 105.461M68.1664 118.116L68.3044 105.461M68.3044 105.461C72.7809 105.703 73.1876 99.9644 73.3007 97.5262C73.3912 95.5757 73.2985 91.4392 73.2409 89.6147M71.9383 116.359L71.416 111.998C73.5599 112.022 76.0847 112.054 78.8305 112.092M116.992 113.096C115.838 112.972 113.392 112.853 110.156 112.742M115.436 110.917C114.133 111.332 111.253 112.277 110.156 112.742M110.156 112.742C102.033 112.462 88.9353 112.233 78.8305 112.092M78.8305 112.092L85.3076 140.312M50.9423 89.2317L84.9664 94.276",
    stroke: "#058868",
    strokeWidth: 0.945908
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_527_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 114,
    width: 23,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.217 114.175L63.234 115.702L60.9237 128.21C62.2804 127.841 64.9071 128.292 67.1605 129.499C69.6731 130.846 70.3782 133.073 73.1945 135.68C75.4475 137.766 80.1089 137.163 82.158 136.602L73.217 114.175Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_527_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.217 114.175L63.234 115.702L60.9237 128.21C62.2804 127.841 64.9071 128.292 67.1605 129.499C69.6731 130.846 70.3782 133.073 73.1945 135.68C75.4475 137.766 80.1089 137.163 82.158 136.602L73.217 114.175Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.693 114.125L73.2827 120.754M79.835 137.528L77.5261 131.617M77.5261 131.617C73.7112 131.472 72.3127 132.546 70.541 135.591M77.5261 131.617L73.2827 120.754M73.2827 120.754C69.1695 121.954 67.0012 119.735 64.7659 114.402M71.7565 127.168C69.8175 128.553 69.0262 129.637 68.3248 132.309M68.8665 125.293C67.3555 126.797 66.4632 128.145 65.9401 130.499",
    stroke: "#616987",
    strokeWidth: 0.945908
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7203 64.7857C55.0845 60.4818 56.609 50.1323 59.7431 43.5521C62.5669 42.2185 68.3235 39.4675 70.674 42.5218C73.0244 45.5762 73.812 59.878 73.6789 66.1751L54.7203 64.7857Z",
    fill: "#2F3030"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_527_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 38,
    width: 15,
    height: 22
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.4782,
    cy: 48.9732,
    rx: 6.81308,
    ry: 10.1223,
    transform: "rotate(0.134695 65.4782 48.9732)",
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_527_14422)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.4782,
    cy: 48.9732,
    rx: 6.81308,
    ry: 10.1223,
    transform: "rotate(0.134695 65.4782 48.9732)",
    fill: "#F2CBB9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.4729,
    cy: 42.071,
    rx: 7.75615,
    ry: 11.6036,
    transform: "rotate(45.7711 60.4729 42.071)",
    fill: "#2F3030"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.75615,
    ry: 11.6036,
    transform: "matrix(-0.857787 0.514005 0.514005 0.857787 74.748 40.9855)",
    fill: "#2F3030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_527_14422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 93,
    height: 92
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.194 91.8707L50.7043 87.7697C50.19 83.7082 50.122 81.1256 50.87 75.3171L30.975 18.2859C29.3054 15.9335 25.7162 10.6376 24.7161 8.27248C23.4658 5.3161 26.5272 4.82904 28.0221 7.4766C26.7223 4.37749 27.9657 2.15468 30.8298 5.79818C29.7893 2.80099 32.2648 0.534237 34.0162 3.82841C35.4172 6.46375 36.8767 8.72059 37.4312 9.5196C37.968 8.36306 39.3915 6.08195 40.7921 6.20984C42.1927 6.33773 41.0778 12.0386 40.3452 14.873L58.3449 62.3909L75.4789 63.1915L101.761 14.15C101.343 11.779 100.736 6.6442 101.649 5.07337C102.562 3.50254 103.993 6.08272 104.594 7.56917C105.096 6.15824 106.32 2.90173 107.2 1.16312C108.301 -1.01015 110.323 0.207062 109.822 3.00357C112.05 0.0232063 114.258 0.855862 113.554 4.17092C115.648 1.1731 117.573 3.12729 116.578 6.06372C115.781 8.41286 93.4334 53.8559 82.359 76.2838C82.6052 80.9753 82.9169 90.6609 82.194 91.8707Z",
    fill: "#01B388"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_527_14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.194 91.8707L50.7043 87.7697C50.19 83.7082 50.122 81.1256 50.87 75.3171L30.975 18.2859C29.3054 15.9335 25.7162 10.6376 24.7161 8.27248C23.4658 5.3161 26.5272 4.82904 28.0221 7.4766C26.7223 4.37749 27.9657 2.15468 30.8298 5.79818C29.7893 2.80099 32.2648 0.534237 34.0162 3.82841C35.4172 6.46375 36.8767 8.72059 37.4312 9.5196C37.968 8.36306 39.3915 6.08195 40.7921 6.20984C42.1927 6.33773 41.0778 12.0386 40.3452 14.873L58.3449 62.3909L75.4789 63.1915L101.761 14.15C101.343 11.779 100.736 6.6442 101.649 5.07337C102.562 3.50254 103.993 6.08272 104.594 7.56917C105.096 6.15824 106.32 2.90173 107.2 1.16312C108.301 -1.01015 110.323 0.207062 109.822 3.00357C112.05 0.0232063 114.258 0.855862 113.554 4.17092C115.648 1.1731 117.573 3.12729 116.578 6.06372C115.781 8.41286 93.4334 53.8559 82.359 76.2838C82.6052 80.9753 82.9169 90.6609 82.194 91.8707Z",
    fill: "#F2CBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2631 56.8337L55.1292 48.8901L57.5224 57.7187L70.7883 59.4464C71.217 59.5022 78.1058 51.0421 81.4966 46.805L96.9634 57.2681C96.0978 69.6696 94.3964 94.5582 94.5153 94.9007C94.6639 95.3289 47.2229 90.2407 46.6869 90.1709C46.2582 90.1151 42.2258 67.9228 40.2631 56.8337Z",
    fill: "#752467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2763 14.5718C33.5038 14.4572 34.2535 14.6693 35.6904 15.5615C35.2022 13.3938 35.3824 12.3794 35.9837 10.6939M29.4034 10.9953C29.2869 10.8438 27.3315 7.02343 26.1893 5.33027M32.3626 9.20033L28.9301 3.64314M106.476 9.85851C107.064 10.5299 107.858 11.8099 107.666 13.2839C107.942 11.6846 109.852 10.8373 111.324 10.8305M108.862 7.23931C109.132 6.72949 110.585 2.37632 111.228 0.0526415M112.442 8.5232C112.509 8.42298 114.122 3.9952 114.931 1.9657",
    stroke: "#ECA789",
    strokeWidth: 0.945908,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0121 61.4376C62.3982 62.8963 63.2454 65.2047 64.4597 67.0028M74.4533 62.1722C73.9093 63.7436 72.7669 66.2235 71.2819 67.8913M64.4597 67.0028L66.4281 61.5358M64.4597 67.0028C65.2247 68.1357 66.1355 69.066 67.1684 69.4538M67.1684 69.4538C67.4043 69.5424 67.6465 69.6026 67.8949 69.6306C69.127 69.7691 70.2821 69.0143 71.2819 67.8913M67.1684 69.4538L68.846 62.3276M71.2819 67.8913L70.582 62.0768M43.4879 57.1855L54.8908 51.2438M81.5234 49.7384L93.9254 58.0989M75.8279 75.1606C69.8252 79.8928 65.985 81.3351 58.3866 81.9512",
    stroke: "#420134",
    strokeWidth: 0.945908
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateEmailSucceed);
export default __webpack_public_path__ + "static/media/update_email_succeed.b6ef7ccff534685b604467f952cefa66.svg";
export { ForwardRef as ReactComponent };